import { Fragment } from "react";

import Button from "../../components/Button/Button";
import Spacer from "../../components/space/Spacer";
import Text from "../../components/Text";
import { createProjectRoute } from "../CreateProjectNavigator/navigation";
import { useCurrentProject } from "./services/context";

export default function LoggedInHomeScreen() {
    const currentProject = useCurrentProject();
    return (
        <Fragment>
            <Spacer scale={9} />
            <Spacer scale={9} />
            <Spacer scale={9} />
            <Text variant="heading" align="center">
                Bonjour !
            </Text>
            <Spacer scale={9} />
            <Text variant="body" align="center">
                Bienvenue dans votre espace Mon projet adoption
            </Text>
            <Spacer scale={9} />
            {currentProject === null ? <NewProjectSetup /> : <Fragment />}
        </Fragment>
    );
}

function NewProjectSetup() {
    return (
        <Fragment>
            <Button label="Commencer" action={createProjectRoute.getLocation()} />
        </Fragment>
    );
}
